import withVerticalSpacing from '../../hocs/withVerticalSpacing';

import {
    StyledContainer,
    StyledPromoCardLayout,
} from './PromoCardLayout.styled';
import { PromoCardLayoutProperties } from './PromoCardLayout.types';

export const PromoCardLayoutComponent = ({
    id,
    content,
}: PromoCardLayoutProperties) => {
    const numberOfChildren = content.length;

    return (
        <StyledContainer id={id ?? 'promo-cards'}>
            <StyledPromoCardLayout
                data-testid="promo-card-layout"
                data-count={numberOfChildren}
            >
                {content}
            </StyledPromoCardLayout>
        </StyledContainer>
    );
};

export const PromoCardLayout = withVerticalSpacing(PromoCardLayoutComponent);
